var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Base',{ref:"base",attrs:{"on-submit":(params) => _vm.reportsService.updateFormTemplate(params, _vm.$route.params.id),"on-get":(id) => _vm.reportsService.getTemplateById(id),"triger-prevent":_vm.trigerPrevent,"field-details-route":"field-details","templates-route":"templates"}})
}
var staticRenderFns = []

export { render, staticRenderFns }